import React from 'react';
import { Modal } from './Modal';
import { AppDispatch } from '../../schematic/reducer';
import { cancelDeleteSchematic, deleteSchematic } from '../actions';
import { translationService } from '../../services/translationService';

export interface DeleteSchematicModalProps {
  dispatch: AppDispatch;
}

export const DeleteSchematicModal: React.FC<DeleteSchematicModalProps> = ({ dispatch }) => {
  return (
    <Modal
  header={<div>{translationService.getTranslation('deleteSchematic')}</div>}
  body={<p className="modal-delete-text">{translationService.getTranslation('confirmDeleteSchematic')}</p>}
  actions={
    <React.Fragment>
      <button onClick={() => dispatch(cancelDeleteSchematic())}>{translationService.getTranslation('back')}</button>
      <button onClick={() => dispatch(deleteSchematic())} style={{color: '#d5000f'}}>
        {translationService.getTranslation('deleteSchematic')}
      </button>
    </React.Fragment>
  }
  onBackdropClick={() => dispatch(cancelDeleteSchematic())}
  />
  );
};
